import React from 'react';
import { Content_File, InterestedInCardFragment } from '../../../../generated/spin-graphql';
import { SocialCardData, SocialCard } from './SocialCard';
import { gql } from '@urql/core';
import { useAppState } from '../../../../client/providers/AppProvider';

type Props = {
    interestedIn: InterestedInCardFragment;
    viewedAt: any;
};

gql`
    fragment InterestedInCard on espin_notification {
        player_user {
            deleted_at
            player_profile {
                user_id
                first_name
                last_name
                slug
                profile_image {
                    ...SpinContentImageDisplay
                }
            }
        }
    }
`;

export const InterestedInCard: React.FC<Props> = ({ viewedAt, interestedIn }) => {
    const { subtier } = useAppState();

    let fullName: string = '',
        slug: string = null,
        profileImg: Partial<Content_File>,
        deletedUser: boolean = false;
    const fName = interestedIn?.player_user?.player_profile?.first_name;
    const lName = interestedIn?.player_user?.player_profile?.last_name;
    fullName = !fName && !lName ? 'N/A' : `${fName} ${lName}`;
    slug = `players/${interestedIn?.player_user?.player_profile?.slug}`;
    profileImg = subtier >= 2 ? interestedIn?.player_user?.player_profile?.profile_image ?? null : null;
    if (!!interestedIn?.player_user?.deleted_at) {
        deletedUser = true;
    }

    const data: SocialCardData = {
        label: 'New Player Interested In Your College!',
        subLabel: fullName,
        picAltText: `${fullName}'s picture`,
        profileImg,
        slug,
        unread: !viewedAt,
        deletedUser: false,
        subTierRequired: 2,
    };

    return (
        <>
            <SocialCard data={data} />
        </>
    );
};
